import "@/App.css";
import LandingPage from "@/pages/LandingPage";

export default function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}
